<template>
  <div v-if="!deleted" class="text-center">
    <v-menu>
      <template v-slot:activator="{ on: menu }">
        <v-tooltip top>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn
              fab
              x-small
              depressed
              class="mr-1"
              :color="
                !signer.firmado
                  ? 'grey lighten-2 grey--text'
                  : 'teal lighten-1 white--text'
              "
              v-on="{ ...tooltip, ...menu }"
              >{{ abbreviation }}</v-btn
            >
          </template>
          <span>{{
            signer.nombres + ' ' + signer.paterno + ' ' + signer.materno
          }}</span>
        </v-tooltip>
      </template>

      <v-card v-if="!signer.firmado && status.descripcion != 'Cancelado'">
        <v-list>
          <v-list-item>
            <v-list-item-avatar class="justify-center">
              <v-avatar color="indigo lighten-2">
                <span class="white--text text-uppercase">{{
                  abbreviation
                }}</span>
              </v-avatar>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>{{ signer.nombres }}</v-list-item-title>
              <v-list-item-subtitle>{{ signer.paterno }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list dense>
          <v-list-item @click="dialogDelete = true">
            <v-list-item-title>Eliminar</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>

    <v-dialog v-model="dialogDelete" persistent max-width="550">
      <v-card>
        <v-card-title class="headline">{{
           last? signerDeleteLastLabels.questionText : signerDeleteLabels.questionText
        }}</v-card-title>
        <v-card-text>{{
         last? signerDeleteLastLabels.descriptionText : signerDeleteLabels.descriptionText.replace('@', signer.nombreCompleto)
        }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="accent"
            text
            @click="onDeleteSinger"
            :loading="isDeleting"
            >{{ last? signerDeleteLastLabels.positiveButtonText : signerDeleteLabels.positiveButtonText  }}</v-btn
          >
          <v-btn
            color="red darken-1"
            text
            @click="dialogDelete = false"
            :disabled="isDeleting"
            >{{ last? signerDeleteLastLabels.negativeButtonText : signerDeleteLabels.negativeButtonText}}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  signersStoreData,
  signersStoreActions
} from '@/modules/signers/store/signersStoreHelpers'
import { pushNotification, messageErrorResponse } from '@/store/helpers'

export default {
  name: 'SignerAvatar',
  props: {
    signer: {
      type: Object,
      required: true
    },
    status: {
      type: Object
    },
    last: { type: Boolean, default: false}
  },
  data() {
    return {
      abbreviation: '',
      deleted: false,
      dialogDelete: false
    }
  },
  created() {
    this.abbreviation =
      this.signer.nombres.substring(0, 1) + this.signer.paterno.substring(0, 1)
  },
  computed: {
    ...signersStoreData
  },
  methods: {
    ...signersStoreActions,
    onDeleteSinger() {
      this.raiseDeleteSigner()
    },
    async raiseDeleteSigner() {
      this.deleteSignerToDocument(this.signer)
        .then((response) => {
          let result = response.data
          if (result.data.signers[0].success) {
            this.deleted = true
            this.$emit('deleted', this.signer)
          } else {
            this.notificationError(result.data.signers[0])
          }
        })
        .catch(err => {
          this.dialogDelete = false
          this.notificationError(err.data.data.signers[0])
        })
    },
    notificationError(msg) {
      pushNotification(
        this.$store,
        messageErrorResponse(msg) || this.msgSignerServiceDeleteError,
        'error',
        'left'
      )
    }
  }
}
</script>
